import * as yup from 'yup';
import i18n from '../../../../localization/i18n';
import {
    LABEL_FIELD_ERROR_REQUIRED,
    PASSWORD_RESET_LABEL_INVALID_PASSWORD,
    PASSWORD_RESET_LABEL_WRONG_PASSWORD,
} from '../../../../localization/resouceKeys';

const MAX_MIN_DIGIT = 1;

const codeFieldValidation = yup
    .string()
    .matches(/^[0-9]+$/, 'Must be only digits')
    .min(MAX_MIN_DIGIT, 'Must be exactly 6 digits')
    .max(MAX_MIN_DIGIT, 'Must be exactly 6 digits')
    .required(() => i18n.t(LABEL_FIELD_ERROR_REQUIRED));

export const passwordResetValidations = yup.object().shape({
    password: yup
        .string()
        .required(() => i18n.t(LABEL_FIELD_ERROR_REQUIRED))
        .matches(
            /^(?=.{7,})(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9])(?!.*(.)\1{2})(?!.*(.{3,})\2).*$/,
            () => i18n.t(PASSWORD_RESET_LABEL_INVALID_PASSWORD),
        ),
    passwordConfirm: yup
        .string()
        .required(() => i18n.t(LABEL_FIELD_ERROR_REQUIRED))
        .oneOf([yup.ref('password'), null], () =>
            i18n.t(PASSWORD_RESET_LABEL_WRONG_PASSWORD),
        ),
});

export const forgotPasswordValidations = yup.object().shape({
    code1: codeFieldValidation,
    code2: codeFieldValidation,
    code3: codeFieldValidation,
    code4: codeFieldValidation,
    code5: codeFieldValidation,
    code6: codeFieldValidation,
});
